let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lFU9I")).then(() => parcelRequire('1IOoh'));